<template>
    <CompassMenu
        :ref="`contextmenu-${id}`"
        trigger="click"
        customClass="listing-context-menu"
        placement="left-start"
        @open="handleOpenMenu"
        @close="handleCloseMenu"
    >
        <CompassIconButton size="medium" icon="action" />
        <template #dropdown>
            <template v-for="(item, index) in items">
                <CompassMenuGroup
                    v-if="item.subitems"
                    :key="`contextmenu-subitem-${id}-${index}`"
                    placement="left-start"
                    :label="item.label"
                    :disabled="item.disabled"
                >
                    <template #dropdown>
                        <CompassDropdownOption
                            v-for="(subitem, subindex) in item.subitems"
                            :key="`contextmenu-item-${id}-${index}-${subindex}`"
                            :label="subitem.label"
                            :disabled="subitem.disabled"
                            :data-bot="subitem.dataBot"
                            @itemSelected="goto(subitem.action, subitem.target, subitem.type, id)"
                        />
                    </template>
                </CompassMenuGroup>
                <CompassDropdownOption
                    v-else
                    :key="`contextmenu-item-${id}-${index}`"
                    :disabled="item.disabled"
                    :label="item.label"
                    :data-bot="item.dataBot"
                    @itemSelected="goto(item.action, item.target, item.type, id)"
                />
            </template>
        </template>
    </CompassMenu>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    name: 'ListingTableElementMenu',
    props: {
        id: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            initialScrollPosition: 0,
            tableElement: null,
        };
    },
    mounted() {
        this.tableElement = document.querySelector('.el-table__body-wrapper');
    },
    unMounted() {
        this.tableElement.removeEventListener('scroll', this.handleAutoCloseMenu);
    },
    methods: {
        ...popupPanelMapActions(['open']),
        goto(url, target, type) {
            switch (type) {
                case 'js':
                case undefined:
                    window.open(url, target);
                    break;
                case 'vuejs':
                    EventBus.emit(url.event, { params: url.params });
                    break;
                case 'function':
                    this[url.event](url.params);
                    break;
            }
        },
        displayOpportunity(params) {
            this.open({
                key: 'opportunityForm',
                props: {
                    oppId: params.id,
                    linkedtype: params.linkedtype,
                    mode: params.mode,
                    action: params.action,
                    emitEditSuccess: 'listing:refresh',
                },
            });
        },
        displayDocpreview(params) {
            this.open({
                key: 'documentPreview',
                props: {
                    id: params.id,
                    linkedtype: params.linkedtype,
                },
            });
        },
        handleAutoCloseMenu() {
            const allowedScroll = 41;
            const currentScrollPosition = this.tableElement.scrollTop;

            if (
                currentScrollPosition > this.initialScrollPosition + allowedScroll ||
                currentScrollPosition < this.initialScrollPosition - allowedScroll
            ) {
                this.$refs[`contextmenu-${this.id}`].isVisible = false;
            }
        },
        handleOpenMenu() {
            this.initialScrollPosition = this.tableElement.scrollTop;
            this.tableElement.addEventListener('scroll', this.handleAutoCloseMenu);
        },
        handleCloseMenu() {
            this.tableElement.removeEventListener('scroll', this.handleAutoCloseMenu);
            this.initialScrollPosition = 0;
        },
    },
};
</script>

<style>
#compass-menu-container .listing-context-menu {
    width: 200px !important;
    z-index: 3 !important;
}
.el-table-column--contextmenu .compass-menu {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.el-table-column--contextmenu .compass-menu .compass-icon {
    cursor: pointer;
}
</style>
